import React, { useState } from 'react';
import { Search, ChevronDown, Tag } from 'lucide-react';
import NavbarComponent from './Navbar';
import FooterComponent from './Footer';
import Seo from '../components/Seo';
import('../css/AdvanceFaq.css')

const AdvancedFAQ = () => {
    const categories = {
        listing: "Property Listing",
        buying: "Buying Process",
        legal: "Legal & Documents",
        account: "Account Management",
        payment: "Payments & Pricing",
        others: "Other Questions"
    };

    const faqs = [
        {
            category: "listing",
            question: "How to verify property ownership before listing?",
            answer: "Before listing your property, please follow these steps: 1) Visit your state's official land records website 2) Verify your land ownership details using your plot number or survey number 3) Once verified, register on KhetBazaar with your: a) Government-issued ID proof b) Property ownership certificate c) Recent photos of the property. This helps ensure authenticity and builds trust with potential buyers."
        },
        {
            category: "buying",
            question: "How can I schedule a property visit?",
            answer: "Once you find an interesting property, you can directly contact the owner through our contact Information. Set up a convenient time for both parties to visit the property. For security, we recommend conducting visits during daylight hours and bringing along trusted associates."
        },
        {
            category: "legal",
            question: "What precautions should I take before buying land?",
            answer: "We recommend: 1) Verify all property documents thoroughly 2) Check local development plans and zoning laws 3) Visit the property personally 4) Consult a local real estate lawyer 5) Verify the seller's identity and ownership rights 6) Check for any pending legal disputes or loans on the property."
        },
        {
            category: "account",
            question: "How do I update my listed properties?",
            answer: "Log into your account, go to 'Profile Settings', select 'My Listing '. Here you can update your listed property, preferred contact method, property visibility settings, and notification preferences."
        },
        {
            category: "payment",
            question: "Are there any fees for listing property?",
            answer: "Basic property listings are free. Premium features like featured listings, advanced analytics, and priority support require a subscription. View our pricing page for detailed information about premium plans and their benefits."
        },
        {
            category: "legal",
            question: "How does KhetBazaar handle property disputes?",
            answer: "While we verify basic listing information, KhetBazaar acts as a platform connecting buyers and sellers. We recommend all parties involve legal professionals for transaction safety. Any disputes should be resolved through appropriate legal channels."
        },
        {
            category: "others",
            question: "Can I list multiple properties under one account?",
            answer: "Yes, you can list multiple properties under a single account. Each property will have its own unique listing ID and dashboard for managing inquiries and updates."
        }
    ];

    const [activeIndex, setActiveIndex] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedCategory, setSelectedCategory] = useState('all');

    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const filteredFAQs = faqs.filter(faq => {
        const matchesSearch = faq.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
            faq.answer.toLowerCase().includes(searchTerm.toLowerCase());
        const matchesCategory = selectedCategory === 'all' || faq.category === selectedCategory;
        return matchesSearch && matchesCategory;
    });

    return (
        <>
            <Seo
                title="Advanced FAQs - KhetBazaar"
                description="Get answers to advanced questions related to land listings and transactions."
                canonical="https://khetbazaar.in/advanced-faqs"
            />

            <div className="advanced-faq-page">
                <NavbarComponent />
                <div className="faq-header">
                    <h1>Frequently Asked Questions</h1>
                    <p>Find detailed answers to all your queries about KhetBazaar</p>

                    <div className="search-box">
                        <Search className="search-icon" />
                        <input
                            type="text"
                            placeholder="Search your question..."
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                </div>

                <div className="categories-section">
                    <button
                        className={`category-btn ${selectedCategory === 'all' ? 'active' : ''}`}
                        onClick={() => setSelectedCategory('all')}
                    >
                        All
                    </button>
                    {Object.entries(categories).map(([key, value]) => (
                        <button
                            key={key}
                            className={`category-btn ${selectedCategory === key ? 'active' : ''}`}
                            onClick={() => setSelectedCategory(key)}
                        >
                            {value}
                        </button>
                    ))}
                </div>

                <div className="faq-container">
                    {filteredFAQs.length === 0 ? (
                        <div className="no-results">
                            <p>No matching questions found. Try a different search term.</p>
                        </div>
                    ) : (
                        filteredFAQs.map((faq, index) => (
                            <div
                                key={index}
                                className={`faq-item ${activeIndex === index ? 'active' : ''}`}
                            >
                                <div className="faq-question" onClick={() => toggleFAQ(index)}>
                                    <h3>{faq.question}</h3>
                                    <div className="faq-meta">
                                        <span className="category-tag">
                                            <Tag className="tag-icon" />
                                            {categories[faq.category]}
                                        </span>
                                        <ChevronDown className="chevron-icon" />
                                    </div>
                                </div>
                                <div className="faq-answer">
                                    <p>{faq.answer}</p>
                                </div>
                            </div>
                        ))
                    )}
                </div>
                <FooterComponent />
            </div>
        </>
    );
};

export default AdvancedFAQ;